// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__89jKg","right":"styles_right__3VZ0T"};